import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { auth } from 'firebase';

@Injectable()
export class AuthService {
  constructor(public af: AngularFireAuth) { }



  loginWithGoogle() {
    return this.af.auth.signInWithPopup(new auth.GoogleAuthProvider()).then((data) => {

    }).catch((error) => {
      console.log(error.message);
    });

  }

  loginWithFacebook() {
    return this.af.auth.signInWithPopup(new auth.FacebookAuthProvider()).then((data) => { }).catch((error) => {
      console.log(error.message)
    });
  }

  logout() {
    return this.af.auth.signOut();
  }



  mergeProvider(credential) {
    var prevUser = this.af.auth.currentUser;

    this.af.auth.signInWithCredential(credential).then(function (user) {
      console.log("Sign In Success", user);
      var currentUser = user;

      return user.delete().then(function () {
        // Link the OAuth Credential to original account
        return prevUser.linkWithCredential(credential);
      }).then(function () {
        // Sign in with the newly linked credential
        return this.af.auth.signInWithCredential(credential);
      });

    })
  }
}